import { LSWH_SYSTEM_PROMPT, SUBJECTS_SYSTEM_PROMPT } from "./aiPrompts";

export const LSWH_CONFIG = {
  systemPrompt: LSWH_SYSTEM_PROMPT,
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    responsibility: v.responsibility,
    organization: v.organization,
    independentWork: v.independentWork,
    collaboration: v.collaboration,
    initiative: v.initiative,
    selfRegulation: v.selfRegulation,
  }),
};

export const SUBJECTS_CONFIG = {
  systemPrompt: SUBJECTS_SYSTEM_PROMPT,
  getStudentReportInfo: (v) => ({
    grade: v.grade,
  }),
};
